import Vue from 'vue'

const state = {
    category: 'all',
    department: 'all',
    reward_user_points: 0,
    reward_user_level_id: null,
    reward_user_level_points: 0
}

const actions = {
    SET_CATEGORY(context, [category]) {
        context.commit('SAVE_CATEGORY', [category])
    },

    SET_DEPARTMENT(context, [department]) {
        context.commit('SAVE_DEPARTMENT', [department])
    },

    SET_REWARD_USER_POINTS(context, [reward_user_points]) {
        context.commit('SAVE_REWARD_USER_POINTS', [reward_user_points])
    },

    SET_REWARD_USER_LEVEL(context, [reward_user_level_id, reward_user_level_points]) {
        context.commit('SAVE_REWARD_USER_LEVEL', [reward_user_level_id, reward_user_level_points])
    },
}

const mutations = {
    SAVE_CATEGORY: (state, [category]) => {
        Vue.set(state, 'category', category)
    },

    SAVE_DEPARTMENT: (state, [department]) => {
        Vue.set(state, 'department', department)
    },

    SAVE_REWARD_USER_POINTS: (state, [reward_user_points]) => {
		Vue.set(state, 'reward_user_points', reward_user_points)
    },

    SAVE_REWARD_USER_LEVEL: (state, [reward_user_level_id, reward_user_level_points]) => {
		Vue.set(state, 'reward_user_level_id', reward_user_level_id)
		Vue.set(state, 'reward_user_level_points', reward_user_level_points)
    },
}

const getters = {
    category: state => {
        return state.category
    },

    department: state => {
        return state.department
    },

    reward_user_points: state => {
        return state.reward_user_points
    },

    reward_user_level_id: state => {
        return state.reward_user_level_id
    },

    reward_user_level_points: state => {
        return state.reward_user_level_points
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}